import { render, staticRenderFns } from "./liveEventsDetail.vue?vue&type=template&id=f2a9ffb2&scoped=true&"
import script from "./liveEventsDetail.vue?vue&type=script&lang=js&"
export * from "./liveEventsDetail.vue?vue&type=script&lang=js&"
import style0 from "./liveEventsDetail.vue?vue&type=style&index=0&id=f2a9ffb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a9ffb2",
  null
  
)

export default component.exports